import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getOrganizationGroup() {
  return httpService.get(ApiUrl.ORGANIZATIONGROUP);
}

const obj = { getOrganizationGroup };

export default obj;
